React = require 'react'
t = require('views/internal/recup-with-helpers')()
naiveShouldComponentUpdate = require 'lib/util/naive-should-component-update'

module.exports = class extends React.Component
  displayName: 'BoardListItemBadgeComponent'
  render: t.renderable ->
    { icon, text, title, iconClass } = @props

    t.span '.board-tile-badges-item', { title }, ->
      t.icon icon,
        class: ["board-tile-badges-item-icon", iconClass].join(' ')
      if text?
        t.span '.board-tile-badges-item-name', ->
          t.text text

  shouldComponentUpdate: naiveShouldComponentUpdate



// WEBPACK FOOTER //
// ./app/scripts/views/badges/board-list-item-badge-component.coffee